'use client';

import classNames from 'classnames';
import EventNames from 'src/analytics/EventNames';
import { trackClick } from 'src/analytics/Events';
import { Button } from '@get-mosh/msh-shared';
import CardsBeforeAndAfter from 'src/components/Cards/CardsBeforeAndAfter';
import Heading from 'src/components/Heading/Heading';
import TrustpilotStars from 'src/components/Trustpilot/TrustpilotStars';
import Routes from 'src/constants/Routes';
import beforeAndAfterData from 'src/data/beforeAndAfter.json';

const getVerticalDataForVariant = (variation) => {
    return beforeAndAfterData[variation] || beforeAndAfterData.weightloss;
};

const BeforeAndAfter = ({ slice, context }) => (
    <section
        className="w-full overflow-hidden px-4 py-10 md:py-16 md:text-center lg:py-20"
        style={{
            backgroundColor: slice.primary.background || 'bg-green-light',
        }}
    >
        <div className="container">
            <Heading tag="h" level="h2" className="mb-4 text-center">
                {slice.primary.title || 'Before and After'}
            </Heading>
            <div
                className={classNames(
                    (slice.primary.show_read_more_reviews ||
                        slice.primary.cta) &&
                        'mb-8',
                    'flex justify-center',
                )}
            >
                <CardsBeforeAndAfter
                    items={getVerticalDataForVariant(slice.variation)}
                    grid={true}
                />
            </div>
            {slice.primary.cta && (
                <div className="text-center">
                    <Button
                        text={slice.primary.cta}
                        as="a"
                        href={slice.primary.path}
                        onClick={() => {
                            trackClick(EventNames.BUTTON_CLICKED, {
                                pageType: context.pageType,
                                label: slice.primary.cta,
                                link: slice.primary.path,
                                variation: slice.variation,
                                location: slice.slice_type,
                            });
                        }}
                        className={'mb-0'}
                    />
                </div>
            )}
            {slice.primary.disclaimer ? (
                <p className="p2 text-center text-grey-400">
                    {slice.primary.disclaimer}
                </p>
            ) : null}
            {slice.primary.show_read_more_reviews && (
                <a href={Routes.TRUSTPILOT_REVIEWS} target="blank">
                    <TrustpilotStars />
                </a>
            )}
        </div>
    </section>
);

export default BeforeAndAfter;
